import "../../assets/styles/Utils.css";
import { useTranslation } from "react-i18next";

function SpinningLoader() {
  const { t } = useTranslation();

  return (
    <div className="loader-overlay">
      <div className="loader-spinner" role="status">
        <span className="visually-hidden">{t("actions.loading")}</span>
      </div>
    </div>
  );
}

export default SpinningLoader;
